import { render, staticRenderFns } from "./VEmployerEmployees.vue?vue&type=template&id=6d0c33f6&lang=pug"
import script from "./VEmployerEmployees.vue?vue&type=script&lang=ts"
export * from "./VEmployerEmployees.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports